export default "__VITE_ASSET__6dea9a52__"